import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout'

export default new Router({
    scrollBehavior (to, from, savedPosition) {
        // return返回期望滚动到的位置的坐标
        return { x: 0, y: 0 }
    },
    routes: [
        { path: '/404', component: () => import('@/views/404/404.vue'), },
        {
            path: '/',
            component: Layout,
            redirect: '/home',
            children: [
                {
                    path: '/home',//区县
                    name: 'Home',
                    meta:{ activeMenu:'/' },
                    component: () => import('@/views/home/index')
                },
                // {
                //     path: '/countyLevel',//区县
                //     name: 'CountyLevel',
                //     meta:{ activeMenu:'/' },
                //     component: () => import('@/views/home/countyLevel')
                // },
                // {
                //     path: '/municipalLevel',//市
                //     name: 'MunicipalLevel',
                //     component: () => import('@/views/home/municipalLevel')
                // },
                // {
                //     path: '/provincialLevel',//省
                //     name: 'ProvincialLevel',
                //     component: () => import('@/views/home/provincialLevel')
                // },
                // {
                //     path: '/nationalLevel',//全国
                //     name: 'NationalLevel',
                //     component: () => import('@/views/home/nationalLevel')
                // },
                {
                    path: '/liveBroadcast',//正在直播
                    name: 'LiveBroadcast',
                    component: () => import('@/views/liveBroadcast')
                },
                {
                    path: '/liveNotice',//直播预告
                    name: 'LiveNotice',
                    component: () => import('@/views/liveNotice')
                },
                {
                    path: '/liveReview',//直播回顾
                    name: 'LiveReview',
                    component: () => import('@/views/liveReview')
                },
                {
                    path: '/searchPage',//搜索结果页
                    name: 'SearchPage',
                    component: () => import('@/views/searchPage')
                },
                {
                    path: '/detailPlay/:id',//播放详情页
                    name: 'DetailPlay',
                    component: () => import('@/views/detailPlay')
                },
            ]
        },
        { path: '*', redirect: '/404' }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js